import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';

@Enum<GuestStatus>('value')
export class GuestStatus extends EnumType<GuestStatus>() {
   static readonly UNKNOWN = new GuestStatus('unknown', 'guest-status-unknown');
   static readonly ONLINE = new GuestStatus('online', 'guest-status-online');
   static readonly OFFLINE = new GuestStatus('offline', 'guest-status-offline');
   static readonly AWAY = new GuestStatus('away', 'guest-status-away');

   private constructor(public value: string, public styleClass: string = null) {
      super();
   }

   public static valueByString(status: string): GuestStatus {
      const result = _(GuestStatus.values()).find((x) => x.value === status);
      return _.isNil(result) ? GuestStatus.UNKNOWN : result;
   }
}
